import Vue, * as nsVue from 'vue'
import Router, * as nsRouter from 'vue-router'
import App from './App'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Portal from './views/Portal'
import PortalTemplate from './views/PortalTemplate'
import PortalItemList from './views/PortalItemList'
import PortalItemCreate from './views/PortalItemCreate'
import PortalItemUpdate from './views/PortalItemUpdate'
import PortalNodeList from './views/PortalNodeList'
import PortalNodeCreate from './views/PortalNodeCreate'
import PortalNodeUpdate from './views/PortalNodeUpdate'
import AdministratorList from './views/AdministratorList.vue'
import AdministratorCreate from './views/AdministratorCreate.vue'
import AdministratorUpdate from './views/AdministratorUpdate.vue'
import UserList from './views/UserList.vue'
import UserCreate from './views/UserCreate.vue'
import UserUpdate from './views/UserUpdate.vue'
import UniFormList from './views/UniFormList.vue'
import UniFormView from './views/UniFormView.vue'
import globalState from './globalState'

let renderOf404 = (h: nsVue.CreateElement) => 
  h('div', {staticClass: 'page404'}, 'Page Not Found.')

Vue.use(Router)

let routes: nsRouter.RouteConfig[] = [
  { path: '/', name: 'root', component: Home },
  { path: '/login', name: 'login', component: Login },
  { path: '/portal/:portalKey/', name: 'portal', component: Portal, children: [
    { path: ':nodeId/template', name: 'portal-template', component: PortalTemplate },
    { path: ':nodeId/items', name: 'portal-item-list', component: PortalItemList, children: [
      { path: 'create', name: 'portal-item-create', component: PortalItemCreate },
      { path: 'update/:itemId', name: 'portal-item-update', component: PortalItemUpdate },
    ] },
    { path: ':nodeId/nodes', name: 'portal-node-list', component: PortalNodeList, children: [
      { path: 'create', name: 'portal-node-create', component: PortalNodeCreate },
      { path: 'update/:childId', name: 'portal-node-update', component: PortalNodeUpdate },
    ] }
  ] },
  { path: '/administrator', name: 'administrator-list', component: AdministratorList, children: [
      { path: 'create', name: 'administrator-create', component: AdministratorCreate },
      { path: 'update/:id', name: 'administrator-update', component: AdministratorUpdate },
  ] },
  { path: '/user', name: 'user-list', component: UserList, children: [
      { path: 'create', name: 'user-create', component: UserCreate },
      { path: 'update/:id', name: 'user-update', component: UserUpdate },
  ] },
  { path: '/uniForm/:type', name: 'uniForm-list', component: UniFormList, children: [
      { path: 'view/:id', name: 'uniForm-view', component: UniFormView },
  ] },
  { path: '*', component: {render: renderOf404} }
]


export default routes
